import LiveListItem from './LiveListItem';

function PeopleLiveListItem(props) {
  return (
    <LiveListItem
      type="people"
      primaryPath="name"
      secondaryPath="role"
      hideFollow={!props.item.position}
      {...props}
    />
  );
}

export default PeopleLiveListItem;
